<template>
  <div class="header">
    <div class="header-font">木棉树机房3D可视化平台</div>
    <div class="time">{{ this.nowData }} {{ this.nowTime }}</div>
  </div>
</template>

<script>
export default {
  name: 'headerHome',
  data(){
    return {
      nowTime: "", //时间
      nowData: "", //日期
      weekDay: "", //星期
      timer: "", //定时器
    }
  },
  mounted(){
  //  console.log(this.$store);
  },
  created (){
    this.getDate();
    this.timer = setInterval(this.getDate, 500);
  },
  methods:{
    convert(val) {
      return val < 10 ? "0" + val : val;
    },
    getDate() {
      const myDate = new Date();
      //获取当前年
      const year = myDate.getFullYear();
      //获取当前月
      const month = myDate.getMonth() + 1;
      //获取当前日
      const date = myDate.getDate();
      //
      const day = myDate.getDay();
      //获取当前小时数(0-23)
      const h = myDate.getHours();
      //获取当前分钟数(0-59)
      const m = myDate.getMinutes();
      const s = myDate.getSeconds();
      const weeks = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      );

      //获取当前时间
      this.nowTime =
        this.convert(h) + ":" + this.convert(m) + ":" + this.convert(s);
      // this.$store.state.nowTime =
      //   this.convert(h) + ":" + this.convert(m) + ":" + this.convert(s);
      this.nowData =
        year + "/" + this.convert(month) + "/" + this.convert(date);
      this.weekDay = weeks[day];

    },
  },
   destroyed() {
    //清空定时器
    this.timer = null;
  },
}
</script>

<style scoped>
.header {
  width: 100%;
  height:13vh;
  background: url('../assets/img/header.png');
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 13;
}
.header-font {
  font-size: 28px;
  font-weight: 600;
  background-image: -webkit-linear-gradient(bottom, #ffd9b2, #ffffff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-top: 1.5vh;
}

.time {
  position: absolute;
  top: 6.5vh;
  right: 12vw;
}
</style>
